import React, { useEffect, useRef } from "react";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import {
  capitalize,
  formatDateToDMY,
  formatEventDetails,
} from "../Utils/commonFiles";
import PaginationComponent from "../Components/Pagination";
import { toast } from "react-toastify";
import { Col, Row } from "react-bootstrap";
import { Decryptedid } from "../Utils/bcrypt";
import { getSongReqSongs, updateSongRequest } from "../Redux/Actions/event";
import CreateSongsModal from "../Components/CommanModals/CreateSongsModal";
import ConfirmationModal from "../Components/CommanModals/ConfirmationModal";

export default function SongRequests() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const Id = id && Decryptedid(atob(id));
  const navigate = useNavigate();
  const location = useLocation();

  const requestedSongs = useSelector((e) => e.eventAuth.newRequestedSongs);

  const [currentPage, setCurrentPage] = useState(0);
  const [eventCurrPage, setEventCurrPage] = useState(0);
  const [isCheckToggle, setIsCheckToggle] = useState({});
  const [selectedSong, setSelectedSong] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [pendingDecline, setPendingDecline] = useState(null);

  const filteredSongs = requestedSongs?.songs || [];

  const totalEntries = requestedSongs?.total ?? 0;
  const entriesPerPage = 10;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  const handlePageChange = (page) => setCurrentPage(page);

  // const handleChange = async (res) => {
  //   const newStatus = isCheckToggle[res._id] ? "Rejected" : "Approved";

  //   let data = {
  //     songId: res._id,
  //     clientId: res.clientRequest.client._id,
  //     event: res.clientRequest.event._id,
  //     section: res.clientRequest.section,
  //     status: newStatus,
  //   };

  //   setIsCheckToggle((prevState) => ({
  //     ...prevState,
  //     [res._id]: !prevState[res._id],
  //   }));

  //   try {
  //     await dispatch(updateSongRequest(data)).then((res) => {
  //       if (res?.payload?.statusCode === 200) {
  //         Initialize();
  //       } else {

  //         setIsCheckToggle((prevState) => ({
  //           ...prevState,
  //           [res._id]: !prevState[res._id],
  //         }));
  //         toast.error(res?.payload?.message || "Failed to update song status");
  //       }
  //     });
  //   } catch (error) {

  //     setIsCheckToggle((prevState) => ({
  //       ...prevState,
  //       [res._id]: !prevState[res._id],
  //     }));
  //     toast.error("An error occurred while updating song status");
  //     console.error(error);
  //   }
  // };

  useEffect(() => {
    if (requestedSongs?.songs?.length > 0) {
      setIsCheckToggle(
        requestedSongs.songs.reduce(
          (acc, item) => ({
            ...acc,
            [item._id]:
              item.requestedSongStatus === "Rejected"
                ? "Declined"
                : item.requestedSongStatus || "Pending",
          }),
          {}
        )
      );
    } else {
      setIsCheckToggle({});
    }
  }, [requestedSongs]);

  const handleShow = () => setShowModal(true);
  const handleClose = (shouldRefresh = false) => {
    if (shouldRefresh) {
      Initialize();
    }
    setShowModal(false);
    setSelectedSong(null);
  };

  // const handleChange = async (res, newStatus) => {
  //   if (newStatus === "Pending") {
  //     return;
  //   }

  //   const originalStatus = isCheckToggle[res._id] || "Pending";

  //   setIsCheckToggle((prevState) => {
  //     const newState = {
  //       ...prevState,
  //       [res._id]: newStatus,
  //     };
  //     return newState;
  //   });

  //   let data = {
  //     songId: res._id,
  //     clientId: res.clientRequest.client._id,
  //     event: res.clientRequest.event._id,
  //     section: res.clientRequest.section,
  //     status: newStatus === "Declined" ? "Rejected" : newStatus,
  //   };

  //   try {
  //     const response = await dispatch(updateSongRequest(data));
  //     if (response?.payload?.statusCode === 200) {
  //       if (response?.payload?.data?.requestedSongStatus) {
  //         setIsCheckToggle((prevState) => {
  //           const newState = {
  //             ...prevState,
  //             [res._id]:
  //               response.payload.data.requestedSongStatus === "Rejected"
  //                 ? "Declined"
  //                 : response.payload.data.requestedSongStatus,
  //           };
  //           return newState;
  //         });
  //       }
  //       Initialize()
  //     } else {
  //       setIsCheckToggle((prevState) => {
  //         const newState = {
  //           ...prevState,
  //           [res._id]: originalStatus,
  //         };
  //         return newState;
  //       });
  //       toast.error(response?.payload?.message || "Failed to update song status");
  //     }
  //   } catch (error) {
  //     // Revert state on error
  //     setIsCheckToggle((prevState) => {
  //       const newState = {
  //         ...prevState,
  //         [res._id]: originalStatus,
  //       };
  //       return newState;
  //     });
  //     toast.error("An error occurred while updating song status");
  //     console.error("handleChange error:", error);
  //   }
  // };

  const handleChange = async (res, newStatus) => {
    if (newStatus === "Pending") {
      return;
    }

    // Declining needs confirmation first — nothing changes until the admin
    // confirms in the popup.
    if (newStatus === "Declined") {
      setPendingDecline(res);
      return;
    }

    await applyStatusChange(res, newStatus);
  };

  const confirmDecline = async () => {
    if (!pendingDecline) return;
    const res = pendingDecline;
    setPendingDecline(null);
    await applyStatusChange(res, "Declined");
  };

  const cancelDecline = () => {
    setPendingDecline(null);
  };

  const applyStatusChange = async (res, newStatus) => {
    if (newStatus === "Approved") {
      const sectionId = res.clientRequest.section;
      const event = res.clientRequest.event;

      const targetSection = event?.eventSection?.eventSubSection?.find(
        (sub) => sub.section._id === sectionId
      );

      const currentSongs = targetSection?.songs?.length || 0;
      const maxSongs = targetSection?.section?.totalSongs || 0;

      // if (currentSongs >= maxSongs) {
      //   toast.error(
      //     `You cannot approve this request. "${targetSection?.section?.sectionName}" already has the maximum of ${maxSongs} songs.`
      //   );
      //   return;
      // }
    }

    const originalStatus = isCheckToggle[res._id] || "Pending";

    setIsCheckToggle((prevState) => ({
      ...prevState,
      [res._id]: newStatus,
    }));

    let data = {
      songId: res._id,
      clientId: res.clientRequest.client._id,
      event: res.clientRequest.event._id,
      // section: res.clientRequest.section,
      section: res.clientRequest.section?._id,
      status: newStatus === "Declined" ? "Rejected" : newStatus,
    };

    try {
      const response = await dispatch(updateSongRequest(data));
      if (response?.payload?.statusCode === 200) {
        if (response?.payload?.data?.requestedSongStatus) {
          setIsCheckToggle((prevState) => ({
            ...prevState,
            [res._id]:
              response.payload.data.requestedSongStatus === "Rejected"
                ? "Declined"
                : response.payload.data.requestedSongStatus,
          }));
        }
        Initialize();
      } else {
        setIsCheckToggle((prevState) => ({
          ...prevState,
          [res._id]: originalStatus,
        }));
        toast.error(
          response?.payload?.message || "Failed to update song status"
        );
      }
    } catch (error) {
      setIsCheckToggle((prevState) => ({
        ...prevState,
        [res._id]: originalStatus,
      }));
      toast.error("An error occurred while updating song status");
      console.error("handleChange error:", error);
    }
  };

  const Initialize = async () => {
    try {
      const params = new URLSearchParams(location.search);
      const searchQuery = params.get("search") || "";
      dispatch(startstopLoading(true));
      await Promise.all([
        dispatch(
          getSongReqSongs({ limit: 10, page: currentPage, search: searchQuery })
        ),
      ]);
      dispatch(startstopLoading(false));
    } catch (error) {
      dispatch(startstopLoading(false));
      toast.error("Failed to load event data");
      console.error(error);
    }
  };


  useEffect(() => {
    if (requestedSongs?.songs?.length > 0) {
      setIsCheckToggle((prevState) =>
        requestedSongs.songs.reduce(
          (acc, item) => {
            acc[item._id] =
              prevState[item._id] ||
              (item.requestedSongStatus === "Rejected"
                ? "Declined"
                : item.requestedSongStatus || "Pending");
            return acc;
          },
          { ...prevState }
        )
      );
    } else {
      setIsCheckToggle({});
    }
  }, [requestedSongs]);

  const lastSearchRef = useRef(new URLSearchParams(location.search).get("search") || "");

  useEffect(() => {
    // A new search starts from the first page — otherwise e.g. page 3 of a 4-result search shows nothing
    const search = new URLSearchParams(location.search).get("search") || "";
    if (search !== lastSearchRef.current) {
      lastSearchRef.current = search;
      if (currentPage !== 0) {
        setCurrentPage(0); // re-runs this effect, which then loads page 1
        return;
      }
    }
    Initialize();
  }, [currentPage, eventCurrPage, location.search]);

  return (
    <Layout>
      <Container fluid>
        <Row>
          <Col lg={12}>
            <div className="comn-table-title">
              <h3>
                Song Requests <span>({requestedSongs?.total})</span>
              </h3>
            </div>
            <div className="filters">
              <div className="inner-filter-field">
                <div class="table-responsive">
                  <Table size="sm" className="table-cmn">
                    <thead>
                      <tr>

                        <th>
                          <div className="user-checkbox">Package</div>
                        </th>
                        <th>
                          <div className="user-checkbox">Client Name</div>
                        </th>
                        <th>
                          <div className="user-checkbox">Wedding Date</div>
                        </th>
                        <th>
                          <div className="user-checkbox">Song Title</div>
                        </th>
                        <th>
                          <div className="user-checkbox">Artist</div>
                        </th>
                        <th>
                          <div className="user-checkbox">Section</div>
                        </th>

                        <th>Status</th>
                        <th>
                          <div className="user-checkbox">comments</div>
                        </th>


                        <th>
                          <div className="user-checkbox">Link</div>
                        </th>
                        <th>
                          <div className="user-checkbox">Action</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredSongs.map((requestedSongsRes, i) => {
                        // safely get the eventSubSection array (eventSection is an array)
                        const sectionNames =
                          requestedSongsRes?.clientRequest?.section
                            ?.sectionName;


                        return (
                          <tr key={i}>


                            <td>
                              <div className="first-user">
                                <div className="user-profile">
                                  {capitalize(
                                    requestedSongsRes?.clientRequest?.event
                                      ?.eventName
                                  )}
                                </div>
                              </div>
                            </td>

                            <td>
                              <div className="first-user">
                                <div className="user-profile">
                                  {
                                    requestedSongsRes?.clientRequest?.client
                                      ?.fullName
                                  }
                                </div>
                              </div>
                            </td>

                            <td>
                              <div className="first-user">
                                <div className="user-profile">
                                  {formatDateToDMY(
                                    requestedSongsRes?.clientRequest?.event
                                      ?.eventDate
                                  )}
                                </div>
                              </div>
                            </td>

                            <td>
                              <div className="first-user">
                                <div className="user-profile">
                                  {requestedSongsRes?.title}
                                </div>
                              </div>
                            </td>

                            <td>
                              <div className="first-user">
                                <div className="user-profile">
                                  {requestedSongsRes?.artist}
                                </div>
                              </div>
                            </td>

                            <td>
                              <div className="first-user">
                                <div className="user-profile">
                                  {sectionNames}
                                </div>
                              </div>
                            </td>


                            <td>
                              <div className="mb-3 comp-pending-drop">
                                <select
                                  id={`category`} // Fixed ID to be unique
                                  value={
                                    isCheckToggle[requestedSongsRes?._id] ||
                                    "Pending"
                                  }
                                  onChange={(e) =>
                                    handleChange(
                                      requestedSongsRes,
                                      e.target.value
                                    )
                                  }
                                  className={`form-control ${isCheckToggle[requestedSongsRes?._id] ===
                                    "Declined" ||
                                    isCheckToggle[requestedSongsRes?._id] ===
                                    "Pending"
                                    ? "me-4"
                                    : ""
                                    } custom-select`}
                                >
                                  <option disabled value="">
                                    Select
                                  </option>
                                  <option value="Pending">Pending</option>
                                  <option value="Approved">Approved</option>
                                  <option value="Declined">Declined</option>
                                </select>
                              </div>
                            </td>

                            <td>
                              <div className="first-user">
                                <div className="user-profile">
                                  {requestedSongsRes?.clientRequest?.comment}
                                </div>
                              </div>
                            </td>



                            <td>
                              <div className="first-user">
                                <div className="user-profile">
                                  {requestedSongsRes?.url}
                                </div>
                              </div>
                            </td>

                            <td>
                              <div className="mb-3 comp-pending-drop">
                                <div className="comn-table-title m-0">
                                  {requestedSongsRes?.isAddedLibrary
                                    ?
                                    <>Song Added</>
                                    :
                                    <button
                                      disabled={requestedSongsRes?.isAddedLibrary}
                                      onClick={() => {
                                        setSelectedSong({
                                          title: requestedSongsRes?.title || "",
                                          artist: requestedSongsRes?.artist || "",
                                          genre: requestedSongsRes?.genre || "",
                                          fromSongRequest: true,
                                          requestedSongId: requestedSongsRes?._id
                                        });
                                        setShowModal(true);
                                      }}
                                    >
                                      {'Add Song'}
                                    </button>}
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  {filteredSongs.length === 0 && (
                    <div className="song-requests-data">
                      <div className="no-data-found">
                        <p>No Data</p>
                      </div>
                    </div>
                  )}
                  {requestedSongs?.total > 1 && (
                    <PaginationComponent
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                      totalEntries={totalEntries}
                      entriesPerPage={entriesPerPage}
                    />
                  )}
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <CreateSongsModal
          show={showModal}
          handleClose={handleClose}
          selectedSong={selectedSong}
        />
        <ConfirmationModal
          show={!!pendingDecline}
          handleClose={cancelDecline}
          handleSubmit={confirmDecline}
          message="Do you want to remove it from the list?"
        />
      </Container>
    </Layout>
  );
}
